module.exports = __webpack_public_path__ + "img/header-weddingRingsForestGreen@2x.b1a8460.jpg";